export { default } from './GuideCard';
